const BASE_URL = "https://remember-pi-project-alexa2me.vercel.app";
// const BASE_URL =  "http://localhost:3304";

export default BASE_URL;
